import Spinner from '@/components/basic/Spinner';
import {SaveButton} from '@/components/refinedev/action_buttons';
import EditForm from '@/components/refinedev/pages/edit-form';
import RichTextInput from '@/components/refinedev/RichTextInput';
import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import {apiService} from '@/lib/ApiService';
import {defaultMutationOptions, defaultQueryOptions} from '@/pages/_utils';
import {Button} from '@/shadcn_components/ui/button';
import {useMutation, useQuery} from '@tanstack/react-query';
import {useCallback, useEffect} from 'react';
import {FormProvider, useForm} from 'react-hook-form';

const ProjectNotes = () => {
  const resParams = useMyResourceParams();

  // load data
  const query = useQuery({
    queryKey: ['personal-note-query', 'project', String(resParams.id) || ''],
    queryFn: async () => {
      if (!resParams.id) return;
      return await apiService.projects.personalNotes.load(String(resParams.id));
    },
    enabled: !!resParams.id,
    ...defaultQueryOptions,
  });

  const form = useForm({defaultValues: query.data || {}});
  useEffect(() => {
    if (query.data) form.reset(query.data);
  }, [query.data]);

  const update = useMutation({
    mutationKey: ['personal-note-mutate', 'project', String(resParams.id) || ''],
    mutationFn: async (data: any) => {
      return await apiService.projects.personalNotes.save(String(resParams.id), data.content);
    },
    ...defaultMutationOptions,
  });

  const onSubmit = useCallback(
    async data => {
      const tranformedData = transformBeforeSave(data);
      await update.mutateAsync(tranformedData);
    },
    [update],
  );

  if (!resParams.id) return <p>Đường dẫn không hợp lệ</p>;
  if (query.isLoading) return <Spinner />;

  return (
    <FormProvider {...form}>
      {/* <form onSubmit={form.handleSubmit(onSubmit)}> */}
        <div className="flex flex-row gap-4 items-center">
          <h1 className="text-2xl font-semibold">Ghi chép cá nhân</h1>
          <Button
            type="button"
            size="sm"
            className="mt-2"
            disabled={update.isLoading}
            onClick={form.handleSubmit(onSubmit)}>
            Lưu
          </Button>
        </div>
        <RichTextInput source="content" className="h-full" />
      {/* </form> */}
    </FormProvider>
  );
};

function transformBeforeSave(inputData) {
  const data = {...inputData};
  return data;
}

export default ProjectNotes;
